import { forwardRef } from 'react';
import ChatMessage from './ChatMessage';
import { constant } from '../../config/constant';

const { ASSISTANT } = constant;

const ChatMessages = forwardRef(function ChatMessages(
  { messages, isRespLoading, chatId },
  ref
) {
  return (
    <div className="flex-1 pr-1 space-y-4">
      <>
        {messages.map((msg, idx) => {
          const isLast = idx === messages.length - 1;

          // Find the corresponding user message for assistant responses
          const userMessageId = msg.role === ASSISTANT && idx > 0
            ? messages[idx - 1]?.id || null
            : null;

          // Find the actual user message text for assistant responses
          const userMessage = msg.role === ASSISTANT && idx > 0
            ? messages[idx - 1]?.message || null
            : null;

          return (
            <ChatMessage
              key={msg.id || idx}
              text={msg.message}
              sender={msg.role}
              isRespLoading={false}
              isTyping={msg.isTyping === true} // Animate only if flagged
              isStreaming={msg.isStreaming === true} // Pass streaming flag
              isTerminated={msg.isTerminated === true} // Pass terminated flag
              scrollRef={isLast && (msg.isTyping || msg.isStreaming) ? ref : null}
              chatId={chatId}
              messageId={msg.id}
              userMessageId={userMessageId}
              userMessage={userMessage}
              assistantMessageId={msg.role === ASSISTANT ? msg.id : null}
            />
          );
        })}

        {isRespLoading && (
          <ChatMessage
            key="loading"
            text=""
            sender={ASSISTANT}
            isRespLoading={true}
            scrollRef={ref}
            chatId={chatId}
          />
        )}
      </>
      <div ref={ref} />
    </div>
  );
});

export default ChatMessages;
